module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/grievence-lodging/grievence-grid/grievence-grid.component.css
// module id = ./src/app/grievence-lodging/grievence-grid/grievence-grid.component.css
// module chunks = main